import { render, staticRenderFns } from "./IconLockKeyhole.vue?vue&type=template&id=a06e63be"
import script from "./IconLockKeyhole.vue?vue&type=script&lang=js"
export * from "./IconLockKeyhole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports